import { memoizeWith, identity } from 'ramda';
function getCustomTooltipThemeStyles(theme) {
  return require("./".concat(theme, ".module.css"));
}
export var getThemeStyles = memoizeWith(identity, getCustomTooltipThemeStyles);